import type { TextAreaElement } from './types'

import styled from 'styled-components'

import { baseInputCSS } from './base-input-css'

export const TextArea = styled.textarea<TextAreaElement>`
  resize: ${({ $noResize }) => ($noResize ? 'none' : 'vertical')};
  ${baseInputCSS}
`
